export const limiteCaracteres = {
    RELAT_ACOMP_ASSINATURA: 33,
    RELAT_ACOMP_OBS_ITEM: 250
}